import { Availability } from "../Availability";
export class QrWaiterPurchaseOrderFulfillmentTime {
    constructor() {
        this.type = "QrWaiter";
    }
    get availability() {
        return Availability.available();
    }
}
